import React from "react";
import feature from "../../Assets/imgNewUI/featured.svg";
import { TruncateName } from "../../Utility/Utility";
const CommonMobileOffer = ({
  deal,
  matchingCoupon,
  isFeature,
  handleDealCoupon,
  bgImg,
  index,
  couponCount,
  clientCode
}) => {
  return (
    <div key={index} className="w-25 relative mt-4 offer-img-width">
      <div
        className="relative card-top-offer"
        onClick={() => handleDealCoupon(deal)}
      >
        <div className="top-offer-img overflow-hidden">
          <img
            onClick={() => handleDealCoupon(deal)}
            className={deal?.mobImage ? "object-cover top-img-rads relative z-[1] offer-img-placeholder" : "object-cover top-img-rads relative z-[1] offer-img-placeholder"}
            src={deal?.mobImage? `${process.env.REACT_APP_CLIENT_IMAGE_URL}${deal?.mobImage}`:`${process.env.REACT_APP_CLIENT_IMAGE_URL}${clientCode}/img/Placeholder.svg`}
            onError={(e) => (e.target.src = `${process.env.REACT_APP_CLIENT_IMAGE_URL}${clientCode}/img/Placeholder.svg`)}
            alt={matchingCoupon?.title}
          />

          <div className="absolute top-2 left-3 top-offer px-4 z-[1] mt-1">
            {couponCount?.length > 1
              ? `${couponCount?.length} Offers`
              : "1 Offer"}
          </div>

          {isFeature ? (
            <>
              <div>
                <img className="featured_tag" src={feature} alt="feature" />
              </div>
            </>
          ) : (
            ""
          )}
          <div className="absolute inset-0 z-[1]">
            <div className="back-img w-full h-full bg-gradient-to-t from-black/60 via-black/20 to-transparent px-3 pt-24 pb-3 flex items-end">
              {/* future use  */}
              <span
                title={matchingCoupon?.title}
                className="block cursor-pointer title-sz"
              >
                {TruncateName(matchingCoupon?.title, 28)}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-2 ml-1 pl-2">
        <h4
          title={deal?.name}
          onClick={() => handleDealCoupon(deal)}
          className="font-medium cursor-pointer"
        >
          {TruncateName(deal?.name, 15)}
        </h4>
      </div>
    </div>
  );
};

export default CommonMobileOffer;
